export function onBottom(callback) {
  window.onscroll = () => {
    // document.body.scrollTop alone should do the job but that actually works only in case of Chrome.
    // With IE and Firefox it also works sometimes (seemingly with very simple pages where you have
    // only a <pre> or something like that) but I don't know when. This hack seems to work always.
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;

    // Grodriguez's fix for scrollHeight:
    // accounting for cases where html/body are set to height:100%
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;

    // >= is needed because if the horizontal scrollbar is visible then window.innerHeight includes
    // it and in that case the left side of the equation is somewhat greater.
    const scrolledToBottom = scrollTop + window.innerHeight >= scrollHeight;

    if (scrolledToBottom) {
      callback();
    }
  };
  window.onscroll();
}



// WEBPACK FOOTER //
// ./src/services/infinite-loading.js